import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getLegalDocs } from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPolicy() {
  const [doc, setDoc] = useState(null);
  useEffect(() => {
    getLegalDocs().then((d) => setDoc(d.privacy)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAF7] py-12 px-4">
      <div className="max-w-3xl mx-auto bg-white border border-[#E7E5E0] rounded-2xl p-8">
        <Link to="/" className="inline-flex items-center gap-1 text-sm text-[#6B6B70] mb-6 hover:text-[#0F0F10]">
          <ArrowLeft className="w-4 h-4" /> Back
        </Link>
        <h1 className="font-display text-3xl font-semibold mb-2">Privacy Policy</h1>
        {doc && (
          <p className="text-sm text-[#6B6B70] mb-6">
            Version {doc.version} · Effective {doc.effective_date}
          </p>
        )}
        <pre className="whitespace-pre-wrap font-sans text-sm text-[#404040] leading-relaxed">
          {doc?.text || "Loading…"}
        </pre>
      </div>
    </div>
  );
}